export default __webpack_public_path__ + "static/media/christmas-base.519b3aec.png";